import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  SxProps,
  Theme,
  useTheme,
} from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import useGlobalContext from "hooks/globalData";
import { useQuery } from "react-query";
import { useParams, Link } from "react-router-dom";
import { FormattedMessage as T } from "react-intl";
import { CourseDetailsRequest } from "services/organizationPortalClient";

const useStyles = (_: Theme): { [key: string]: SxProps } => ({
  registerButton: {
    float: "right",
  },
  courseDetails: {
    marginTop: "20px",
  },
});

export function CourseDetails() {
  const styles = useStyles(useTheme());
  const { courseService, courseDetailsEnrollUsersUrl } = useGlobalContext();

  let { id } = useParams();

  const { data, isFetching } = useQuery(["course-details", id], () =>
    courseService.getCourseDetails(
      CourseDetailsRequest.fromJS({
        skuId: id,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      })
    )
  );

  return (
    <Box>
      {isFetching ? (
        <Grid container justifyContent="center">
          <CircularProgress />
        </Grid>
      ) : (
        <>
          <Box>
            <RedirectBackButton labelKey="back" />
            <Link to={courseDetailsEnrollUsersUrl(id)}>
              <Button
                startIcon={<AddIcon />}
                variant="contained"
                sx={styles.registerButton}
              >
                <T id="register" />
              </Button>
            </Link>
          </Box>
          <Box sx={styles.courseDetails}>
            <span
              dangerouslySetInnerHTML={{
                __html: data?.value!,
              }}
            />
          </Box>
        </>
      )}
    </Box>
  );
}
